export default class NewsletterPopup {
    constructor(node) {
        let _this = this;
        this.node = node;

        $.fancybox.open({
            src  : '#' + this.node.id,
            type : 'inline',
            afterClose : function() {
                _this.setHideCookie();
            }
        });
        
        this.addListeners();
    }
    
    addListeners() {
		let _this = this;

		if (this.node.querySelector('input[type="submit"]') !== null) {
			this.node.querySelector('input[type="submit"]').addEventListener('click', function () {
				_this.setHideCookie();
			});
		}
    }
    
    setHideCookie() {
        document.cookie = "newsletterPopup=hide; expires=0; path=/";
    }

    static init() {
        let newsletterPopupNode = document.querySelector("[data-newsletter-popup]");

        if (newsletterPopupNode) {
            return new NewsletterPopup(newsletterPopupNode);
        }
    }
}
